var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-badge-container",class:{ 'variant--active': _vm.active }},[_c('i',{staticClass:"bubble"}),_c('p',[_vm._v(_vm._s(_vm.active ? _vm.$t((_vm.tPrefix + ".active")) : _vm.$t((_vm.tPrefix + ".inactive"))))])])}
var staticRenderFns = []

export { render, staticRenderFns }